import { render, staticRenderFns } from "./CommunityInfo.vue?vue&type=template&id=4e79ac53&scoped=true&"
import script from "./CommunityInfo.vue?vue&type=script&lang=js&"
export * from "./CommunityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e79ac53",
  null
  
)

export default component.exports